import { render } from "./fournisseurs_manage.vue?vue&type=template&id=4df5cb36"
import script from "./fournisseurs_manage.vue?vue&type=script&lang=js"
export * from "./fournisseurs_manage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__